// import History from './History';

export default {
  priority: 1,
  path: "history",
  permissions: ["RequestsMenu/HistoryMenu"], //['RequestDashboardMenu'],
  // component: History,
  component: load(() =>
    import(/* webpackChunkName: "Requests-History" */ "./History")
  ),
  name: app.translate("routes.home.requests.History"),
  icon: "history",
  drawer: true,
};
